export const SHARE_URL = 'Web.TemplatesInterface.v1_0.Touch.DialogTemplateInterface.ShareUrlMethod';
